import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const HomeLine = ({ width = 18, height = 18, fill = '#4C5053', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 13.8317H7.00969V10.0528C7.00969 9.86081 7.07462 9.69981 7.2045 9.56981C7.3345 9.43994 7.4955 9.375 7.6875 9.375H10.3125C10.5045 9.375 10.6655 9.43994 10.7955 9.56981C10.9254 9.69981 10.9903 9.86081 10.9903 10.0528V13.8317H13.5V7.197C13.5 7.15863 13.4916 7.12381 13.4747 7.09256C13.4579 7.06131 13.4351 7.03363 13.4063 7.0095L9.13706 3.80044C9.09856 3.76681 9.05288 3.75 9 3.75C8.94713 3.75 8.90144 3.76681 8.86294 3.80044L4.59375 7.0095C4.56488 7.03363 4.54206 7.06131 4.52531 7.09256C4.50844 7.12381 4.5 7.15863 4.5 7.197V13.8317ZM3.375 13.8317V7.197C3.375 6.98238 3.423 6.77906 3.519 6.58706C3.61512 6.39494 3.74787 6.23675 3.91725 6.1125L8.18663 2.89613C8.4235 2.71538 8.69425 2.625 8.99888 2.625C9.3035 2.625 9.575 2.71538 9.81338 2.89613L14.0828 6.1125C14.2521 6.23675 14.3849 6.39494 14.481 6.58706C14.577 6.77906 14.625 6.98238 14.625 7.197V13.8317C14.625 14.1384 14.5142 14.4026 14.2926 14.6243C14.0709 14.8459 13.8068 14.9567 13.5 14.9567H10.5433C10.3512 14.9567 10.1902 14.8917 10.0603 14.7617C9.93031 14.6318 9.86531 14.4708 9.86531 14.2787V10.5H8.13469V14.2787C8.13469 14.4708 8.06969 14.6318 7.93969 14.7617C7.80981 14.8917 7.64881 14.9567 7.45669 14.9567H4.5C4.19325 14.9567 3.92906 14.8459 3.70744 14.6243C3.48581 14.4026 3.375 14.1384 3.375 13.8317Z"
        fill={fill}
      />
    </Svg>
  );
};

export default HomeLine;
